import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Skeleton } from 'antd';
import { AvatarText } from 'components/Shared/AvatarText';
import { Icon } from 'components/UI/Icon';
import { useCartHandlers } from 'hooks/cart/useCartHandlers';
import { useMediaLoaded } from 'hooks/generic/useMediaLoaded';
import * as Styled from './styles';
import { TrashAlternative } from 'icons';
import { ICartNft } from 'interfaces';

type TCartTileProps = {
  cartItem: ICartNft;
  disabled?: boolean;
};

export const CartTile: FC<TCartTileProps> = ({
  cartItem,
  disabled = false
}) => {
  const { t } = useTranslation();
  const { handleRemoveFromCart } = useCartHandlers();
  const { mediaLoaded, onMediaLoad } = useMediaLoaded();

  return (
    <Styled.CartTileWrapper $disabled={disabled}>
      {!mediaLoaded && (
        <Skeleton.Image
          active
          style={{ width: 64, height: 64, borderRadius: 16, gridArea: 'media' }}
        />
      )}
      <Styled.NftMedia
        src={cartItem.preview?.small || cartItem.media?.small || ''}
        onLoad={onMediaLoad}
        loading="lazy"
        $mediaLoaded={mediaLoaded}
      />
      <Styled.CartTileInfo>
        <AvatarText
          text={cartItem.creator_user_name || cartItem.creator_title}
        />
        <Icon
          svg={TrashAlternative}
          clickable={!disabled}
          onClick={() => handleRemoveFromCart(cartItem.id)}
        />
        <Styled.CartTileTitle>{cartItem.name}</Styled.CartTileTitle>
      </Styled.CartTileInfo>
      <Styled.CartTilePriceWrapper>
        <Styled.CartTilePriceLabel>{t('nft.price')}</Styled.CartTilePriceLabel>
        <Styled.CartTilePrice>{cartItem.formatted_price}</Styled.CartTilePrice>
      </Styled.CartTilePriceWrapper>
    </Styled.CartTileWrapper>
  );
};
